import React from 'react';

// Bold geometric icons in the 40K Gallery style:
// sharp angles, gold/yellow tones (#eeb31e / #896728), angular silhouettes.

// Marine icon — angular Space Marine helmet profile
export function MarineIcon({ size = 20, color = '#eeb31e', className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Marine"
    >
      {/* Helmet dome */}
      <path d="M24 4L16 8L12 16L12 28L14 32L24 36L34 32L36 28L36 16L32 8Z" fill={color} />
      {/* Visor slit */}
      <path d="M16 20H32L31 24H17Z" fill="#0a0c10" />
      {/* Cheek plates */}
      <path d="M12 28L14 32L16 30Z" fill="#896728" />
      <path d="M36 28L34 32L32 30Z" fill="#896728" />
      {/* Bottom jaw */}
      <path d="M18 34H30L28 38H20Z" fill={color} opacity="0.7" />
    </svg>
  );
}

// Xenos icon — sharp alien skull with angular horns
export function XenosIcon({ size = 20, color = '#eeb31e', className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Xenos"
    >
      {/* Skull base */}
      <path d="M24 4L36 12L40 24L36 36L24 44L12 36L8 24L12 12Z" fill={color} />
      {/* Horns */}
      <path d="M12 12L4 2L8 10Z" fill="#896728" />
      <path d="M36 12L44 2L40 10Z" fill="#896728" />
      {/* Eye sockets */}
      <path d="M16 18L20 16L22 20L18 22Z" fill="#0a0c10" />
      <path d="M32 18L28 16L26 20L30 22Z" fill="#0a0c10" />
      {/* Angular mouth */}
      <path d="M18 28H30L28 32H20Z" fill="#0a0c10" />
      {/* Jaw */}
      <path d="M20 34L24 40L28 34Z" fill={color} opacity="0.5" />
    </svg>
  );
}

// Servitor icon — lobotomized human with angular cables
export function ServitorIcon({ size = 20, color = '#eeb31e', className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Servitor"
    >
      {/* Skull */}
      <path d="M24 6L34 12L38 22L34 34L24 42L14 34L10 22L14 12Z" fill={color} />
      {/* Eye sockets */}
      <path d="M17 18L21 16L22 20L18 22Z" fill="#0a0c10" />
      <path d="M31 18L27 16L26 20L30 22Z" fill="#0a0c10" />
      {/* Mouth */}
      <path d="M19 28H29L27 32H21Z" fill="#0a0c10" />
      {/* Neural cables left */}
      <path d="M10 22L4 26L6 32" stroke="#896728" strokeWidth="2" fill="none" />
      {/* Neural cables right */}
      <path d="M38 22L44 26L42 32" stroke="#896728" strokeWidth="2" fill="none" />
      {/* Port nodes */}
      <circle cx="4" cy="26" r="2" fill="#896728" />
      <circle cx="44" cy="26" r="2" fill="#896728" />
    </svg>
  );
}

export default MarineIcon;